import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d0bbac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audit-trail-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2" }
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "ls-table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { "data-label": "Date" }
const _hoisted_14 = { "data-label": "Change" }
const _hoisted_15 = { "data-label": "Changed By" }

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "Audit trail " + _toDisplayString(_ctx.applicationName), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.applicationTypeName), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                  return (_openBlock(), _createElementBlock("th", null, [
                    _createElementVNode("p", null, _toDisplayString(h.text), 1)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.loadingContent)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, [
                      _createVNode(_component_LoadingIndicator)
                    ], 8, _hoisted_8)
                  ]))
                : (_ctx.errorLoadingContent)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableHeadings.length
                      }, [
                        _createVNode(_component_ErrorIndicator)
                      ], 8, _hoisted_10)
                    ]))
                  : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.auditTrailData.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableHeadings.length
                        }, "No Records", 8, _hoisted_12)
                      ]))
                    : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.auditTrailData.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.auditTrailData, (aT) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$formatDateTimeTypeA(aT.date)), 1),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(aT.change), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(aT.changeBy), 1)
                          ]))
                        }), 256))
                      : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}